import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  CreateJustificationReverseLogisticsActions as Actions,
  CreateJustificationReverseLogisticsRequestAction as RequestAction,
} from 'store/ducks/justificationsReverseLogistics';

export function* createJustificationReverseLogisticsRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(postData);
    yield call(api.post, `reverse-logistics/configurations/justifications`, formData);
    onSuccess && onSuccess();
    notify('success', 'Justificativa criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
